interface NetworkSVGProps {
  color: string;
  style: React.CSSProperties;
}

const NetworkSVG = ({ color, style }: NetworkSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="53"
    height="52"
    viewBox="0 0 53 52"
    fill="none"
  >
    <path
      d="M33.9254 33.0144C37.7987 29.1411 37.7987 22.8613 33.9254 18.988C30.0521 15.1147 23.7723 15.1147 19.899 18.988C16.0257 22.8613 16.0257 29.1411 19.899 33.0144C23.7723 36.8877 30.0521 36.8877 33.9254 33.0144Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.911 16.0806C24.643 16.0806 22.8052 20.5219 22.8052 25.9988C22.8052 31.4757 24.643 35.917 26.911 35.917C29.1791 35.917 31.0169 31.4757 31.0169 25.9988C31.0169 23.3029 30.572 20.8574 29.8476 19.0682"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6323 22.9018H34.0362"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6323 29.052H34.0362"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.9111 4.56772V12.6676"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9707 6.96216V9.97651L22.1172 13.3093"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9126 6.85765C20.9772 6.85765 21.8403 5.99458 21.8403 4.92992C21.8403 3.86527 20.9772 3.0022 19.9126 3.0022C18.8479 3.0022 17.9849 3.86527 17.9849 4.92992C17.9849 5.99458 18.8479 6.85765 19.9126 6.85765Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.8516 6.96216V9.97651L31.7026 13.3093"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.9097 6.85765C34.9743 6.85765 35.8374 5.99458 35.8374 4.92992C35.8374 3.86527 34.9743 3.0022 33.9097 3.0022C32.845 3.0022 31.9819 3.86527 31.9819 4.92992C31.9819 5.99458 32.845 6.85765 33.9097 6.85765Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.9111 47.4347V39.3324"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9707 45.0378V42.0259L22.1172 38.6907"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9126 48.9978C20.9772 48.9978 21.8403 48.1347 21.8403 47.0701C21.8403 46.0054 20.9772 45.1424 19.9126 45.1424C18.8479 45.1424 17.9849 46.0054 17.9849 47.0701C17.9849 48.1347 18.8479 48.9978 19.9126 48.9978Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.8516 45.0378V42.0259L31.7026 38.6907"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.9097 48.9978C34.9743 48.9978 35.8374 48.1347 35.8374 47.0701C35.8374 46.0054 34.9743 45.1424 33.9097 45.1424C32.845 45.1424 31.9819 46.0054 31.9819 47.0701C31.9819 48.1347 32.845 48.9978 33.9097 48.9978Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.47754 26.0012H13.5774"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.87207 32.9415H10.8864L14.2192 30.7926"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83984 34.9276C6.90449 34.9276 7.76756 34.0646 7.76756 32.9999C7.76756 31.9352 6.90449 31.0722 5.83984 31.0722C4.77518 31.0722 3.91211 31.9352 3.91211 32.9999C3.91211 34.0646 4.77518 34.9276 5.83984 34.9276Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.87207 19.0609H10.8864L14.2192 21.2075"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83984 20.9303C6.90449 20.9303 7.76756 20.0672 7.76756 19.0026C7.76756 17.9379 6.90449 17.0749 5.83984 17.0749C4.77518 17.0749 3.91211 17.9379 3.91211 19.0026C3.91211 20.0672 4.77518 20.9303 5.83984 20.9303Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.3445 26.0013H40.2422"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.9477 32.9415H42.9358L39.6006 30.7926"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.98 34.9276C49.0446 34.9276 49.9077 34.0646 49.9077 32.9999C49.9077 31.9352 49.0446 31.0722 47.98 31.0722C46.9153 31.0722 46.0522 31.9352 46.0522 32.9999C46.0522 34.0646 46.9153 34.9276 47.98 34.9276Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.9477 19.0609H42.9358L39.6006 21.2075"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.98 20.9303C49.0446 20.9303 49.9077 20.0672 49.9077 19.0026C49.9077 17.9379 49.0446 17.0749 47.98 17.0749C46.9153 17.0749 46.0522 17.9379 46.0522 19.0026C46.0522 20.0672 46.9153 20.9303 47.98 20.9303Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.8364 38.4694C35.2786 37.1081 38.0183 34.366 39.3796 30.9263"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4409 30.9263C15.8022 34.3685 18.5443 37.1081 21.9841 38.4694"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9836 13.5305C18.5414 14.8919 15.7993 17.634 14.4404 21.0737"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.3796 21.0737C38.0183 17.6315 35.2762 14.8894 31.8364 13.5305"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NetworkSVG;
